/* eslint-disable camelcase */
// making these string enumerations helps with parsing json
export enum SectionTypes {
    cooking_appliance = 'cooking_appliance',
    corner_radius = 'corner_radius',
    custom_side = 'custom_side',
    cutouts = 'cutouts',
    diagonal_corners = 'diagonal_corners',
    dishwasher = 'dishwasher',
    edge = 'edge',
    faucet = 'faucet',
    refrigerator = 'refrigerator',
    sink = 'sink',
    tear_out_countertop = 'tear_out_countertop',
    plumbing = 'plumbing',
}

// creates a Map from section types, making each key a string to match to incoming json
// SectionTypeNamesMap.get("refrigerator") == 6
export const SectionTypeNamesMap = new Map<string, string | SectionTypes>(
    Object.entries(SectionTypes).filter((x) => !(parseInt(x[0]) >= 0))
);

export const SectionTypeLookupMap = new Map<string, string | SectionTypes>(
    Object.entries(SectionTypes).filter((x) => parseInt(x[0]) >= 0)
);
